module.exports = __webpack_public_path__ + "media/images/care-e91e70df69249a8113864f058b5f6382.svg";